<template>
  <div class="login">
    <div class="content">
      <img src="@/images/logo.png" alt="logo" />
      <Form
        class="form"
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <FormItem label="用户:" prop="username">
          <Input v-model="ruleForm.username" />
        </FormItem>
        <FormItem label="密码:" prop="password">
          <Input v-model="ruleForm.password" type="password" autocomplete="off" />
        </FormItem>
        <FormItem label="确认密码:" prop="checkPass">
          <Input v-model="ruleForm.checkPass" type="password" autocomplete="off" />
        </FormItem>
        <FormItem>
          <div class="btn">
            <Button calss="button" type="primary" @click="submit('ruleForm')">立即登录</Button>
            <p>
              已有账号，
              <router-link to="/login">去登录</router-link>！
            </p>
          </div>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { Form, FormItem, Input, Button } from 'element-ui'

export default {
  name: 'login',
  components: { Form, FormItem, Input, Button },
  data() {
    let username = (rule, value, callback) => {
      if (!value) return callback(new Error('用户名不能为空'))
      return callback()
    }
    let password = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
          return callback()
        }
        return callback()
      }
    }
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        username: '',
        password: '',
        checkPass: '',
      },
      rules: {
        username: [{ validator: username, trigger: 'blur' }],
        password: [{ validator: password, trigger: 'blur' }],
        checkPass: [{ validator: validatePass, trigger: 'blur' }],
      },
    }
  },
  methods: {
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
          console.log(this.ruleForm)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './indes.less';
</style>